import * as React from 'react';
import { css } from 'styled-components';

// Module Context
import { useComponentContext } from 'src/components/common/modules/component-layout/component-context';

// Components
import Layout from 'src/components/common/theme/Layout';
import { checkValue } from 'src/components/common/helper';
import HeroModuleLoader from './global-hero-componet-loader';

//helpers
import { useWindowDimensions } from 'src/components/common/useWindowDimentions';

const GlobalHero: React.FC = () => {
  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    componentProps: { data, id },
  } = useComponentContext();

  const { width: windowWidth } = useWindowDimensions();

  const { components, isColorBars, isOverlayImage, heroData } = data;
  const {
    applyOriginalRatioForBackgroundPhoto,
    heroImage,
    backgroundVideoFile,
    heroVideoYouTubeId,
    heroVideoPosition,
    heroSlimMode,
    partner,
    feedName,
    templateName,
    siteid,
    campaignUrl,
    template,
    mccidData,
    turnOffCropsForHeroImage,
    heroSearchWizData,
    heroLogo,
    heroLogoStyle,
    setVideoHeightDynamic,
    backgroundVideoPath
  } = heroData;

  const isVideoDynamicHeight = (checkValue(setVideoHeightDynamic) && setVideoHeightDynamic === 'True') ? true : false;
  let isHeroDynamicHeight = false;
  isHeroDynamicHeight = (isVideoDynamicHeight && 
                        (checkValue(backgroundVideoFile?.[0]?.url) || checkValue(heroVideoYouTubeId)) && 
                        heroVideoPosition?.toLowerCase() !== 'foreground video') ? true : false;
  const isHeroWizard = (checkValue(heroSearchWizData?.isShowInHero) && heroSearchWizData?.isShowInHero === 'True') ? true : false;
  const isLogoCenterBottom = (checkValue(heroLogo, true) && heroLogoStyle === "Center-bottom") ? true : false;
  let keepOriginalRatioStyles = ['background-position: center center;', 'background-size: 100% !important;'];

  let isApplyBottomPadding = false;
  if(checkValue(heroSearchWizData?.isShowInHero) && windowWidth < 576){
    if(heroSearchWizData?.isShowInHero === 'True'){
      isApplyBottomPadding = true;
    }else{
      isApplyBottomPadding = false;
    }
  } else{
    isApplyBottomPadding = false;
  }

  if (
    checkValue(applyOriginalRatioForBackgroundPhoto) &&
    applyOriginalRatioForBackgroundPhoto.toLowerCase() === 'true'
  ) {
    if (windowWidth > 1024) {
      keepOriginalRatioStyles = ['padding-bottom: 54% !important;'];
    } else if (windowWidth > 767) {
      keepOriginalRatioStyles = ['padding-bottom: 65% !important;'];
    } else if (windowWidth > 375) {
      keepOriginalRatioStyles = ['padding-bottom: 133% !important;'];
    } else {
      keepOriginalRatioStyles = [
        'padding-bottom: 133% !important;',
        'background-position: unset !important;',
        'background-size: cover !important;',
      ];
    }
  }

  const isApplyOriginalRatioForBackgroundPhoto =
    checkValue(heroImage, true) &&
    !checkValue(backgroundVideoFile?.[0]?.url) &&
    !checkValue(heroVideoYouTubeId) &&
    checkValue(applyOriginalRatioForBackgroundPhoto) &&
    applyOriginalRatioForBackgroundPhoto.toLowerCase() === 'true';

  const isFgVideo =
    (checkValue(backgroundVideoPath) || checkValue(heroVideoYouTubeId) || checkValue(backgroundVideoFile?.[0]?.url)) &&
    heroVideoPosition?.toLowerCase() === 'foreground video';

  const isTurnOffCropsForHeroImage = checkValue(turnOffCropsForHeroImage)
    ? turnOffCropsForHeroImage.toLocaleLowerCase() === 'true'
    : false;
  // Dynamic style overrides
  const moduleCss = () => {
    return `
    ${
      isApplyOriginalRatioForBackgroundPhoto
        ? `
          &.keep-hero-bg-original-ratio{
            .global-hero-module-container{
              ${keepOriginalRatioStyles.join('')}
            }
          }
        `
        : ''
    }
    ${
      isHeroDynamicHeight ? 
      `
        .global-hero-module-container{
          height: auto !important;
          min-height: auto !important;
          @media only screen and (max-width: 992px) {
            min-height: auto !important;
          }
        }
        .hero-bg-video-component{
          position: relative;
        }` : ''
    }
    `;
  };

  const loadHeroComponents = () => {
    return components?.map((com) => {
      return HeroModuleLoader(com.module, {
        ...com,
        ...(com?.module === 'heroBreadcrumbModule' || com?.module === 'heroSearchWizardModule'
          ? {
              partner,
              feedName,
              templateName,
              mccidData,
            }
          : {}),
        ...(com?.module === 'heroForegroundVideoModule'
          ? {
              siteid,
              campaignUrl,
              template,
            }
          : {}),
      });
    });
  };

  return (
    <>
      {checkValue(components, true) ? (
        <Layout
          css={css`
            ${moduleCss()}
          `}
          className={`global-hero-section ${isColorBars ? 'with-color-bars' : ''} ${
            isOverlayImage ? 'with-overlay-image' : ''
          } ${isApplyOriginalRatioForBackgroundPhoto ? 'keep-hero-bg-original-ratio' : ''}
          ${
            checkValue(heroSlimMode) && heroSlimMode.toLowerCase() === 'true' ? `hero-slim ${isApplyBottomPadding ? 'slim-padding-bottom':''} ` : ''
          }
          ${isHeroWizard ? 'hasherowizard' : ''}
          ${isLogoCenterBottom ? 'haslogocenterbottom' : ''}
          ${isFgVideo ? 'with-fb-video' : ''} ${
            checkValue(partner) && partner.toLowerCase() !== 'spotlight' ? 'with-breadcrumbs' : ''
          } ${isTurnOffCropsForHeroImage ? 'with-isTurnOffCropsForHeroImage' : ''}
            ${isApplyBottomPadding ? 'apply-padding-bottom' : ''}`}
          HtmlTag="section"
          id={id}
        >
          <div className={`global-hero-module-container`}>{loadHeroComponents()}</div>
        </Layout>
      ) : (
        <></>
      )}
    </>
  );
};

export default GlobalHero;
